import styled from "@emotion/styled";
import { Button, Flex, theme } from "@xometry/xometry_loft";

interface StepProps {
  isCompleted?: boolean;
  isUnlocked?: boolean;
  isActive?: boolean;
}

interface FormContainerProps {
  isSelected: boolean;
}

export const LoadingOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.8);
  padding-top: 25%;
  z-index: 10000;
`;
export const FormStepperBox = styled.div`
  display: grid;
  grid-template-rows: 55px auto 65px;
  grid-template-columns: 280px auto;
  grid-template-areas:
    ". header"
    "stepper content"
    "stepper footer";
  height: 100%;
  width: 100%;
  background-color: ${theme.colors.white};
`;

export const Header = styled(Flex)`
  grid-area: header;
  height: 100%;
  width: 100%;
  border-bottom: 1px solid #dfe6ec;
  align-items: center;
  justify-content: space-between;
  z-index: 99;
`;

export const StepperSpacer = styled(Flex)`
  width: 280px;
  height: 55px;
  border-bottom: 1px solid #dfe6ec;
  background-color: ${theme.colors.blues[5]};
  z-index: 5;
`;
export const Stepper = styled(Flex)`
  grid-area: stepper;
  background-color: ${theme.colors.blues[5]};
  flex-direction: column;
  width: 100%;
  padding: ${theme.space[6]} 0 0 ${theme.space[6]};
  box-sizing: border-box;
`;

export const Step = styled(Flex)<StepProps>`
  flex-direction: row;
  cursor: ${props => (props.isUnlocked ? "pointer" : "default")};
  pointer-events: ${props => (props.isUnlocked ? "auto" : "none")};
  position: relative;
`;

export const StepTitle = styled.span<StepProps>`
  // position absolute prevents two-line titles from pushing down the next step
  position: absolute;
  flex: 1 0 auto;
  font-weight: ${theme.fontWeights.semibold};
  font-size: ${theme.fontSizes[2]};
  color: ${props =>
    props.isUnlocked ? theme.colors.darkBlues[100] : "#DFE6EC"};
  line-height: 20px;
  left: 38px;
  top: 3px;
  max-width: 24ch;
`;

export const StepCircle = styled.div<StepProps>`
  position: relative;
  ${props => (!props.isCompleted ? "background-clip: content-box;" : "")};
  background-color: ${props =>
    props.isActive || props.isCompleted
      ? theme.colors.darkBlues[100]
      : "transparent"};
  border-width: 2px;
  border-style: solid;
  border-color: ${props =>
    props.isActive || props.isUnlocked || props.isCompleted
      ? theme.colors.darkBlues[100]
      : "#DFE6EC"};
  padding: 2px;
  height: 17px;
  width: 17px;
  border-radius: 50%;

  img {
    ${props => (!props.isCompleted ? "display: none;" : "")};
    height: 12px;
    width: 12px;
    position: absolute;
    top: 5px;
    left: 5px;
  }
`;

export const StepLine = styled.div<StepProps>`
  height: 36px;
  margin-left: ${theme.space[3]};
  border-left-width: 2px;
  border-left-style: solid;
  border-left-color: ${props =>
    props.isUnlocked ? theme.colors.darkBlues[100] : "#DFE6EC"};
`;

export const FormSection = styled.div`
  flex: 1 0 auto;
  grid-area: content;
  overflow-y: auto;
`;

export const FormContainer = styled.div<FormContainerProps>`
  display: ${props => (props.isSelected ? "block" : "none")};
  height: 100%;
  max-width: 700px;
  margin: ${theme.space[0]} auto;
  padding: 0 17%;

  @media only screen and (max-width: ${theme.breakpoints[2]}) {
    padding: ${theme.space[10]} 8%;
  }

  /* A few style overrides for FormStepper use cases. TODO: Can we inject these
  in a more graceful way? */
  .custom-field-template {
    margin-bottom: 12px;

    label {
      font-size: 16px;
      margin-bottom: 12px;
      line-height: 24px;
      color: ${theme.colors.darkBlues[100]};
    }

    input {
      padding: 8px 16px;
    }

    /* ant-picker-input has some padding that makes date inputs thicker than
    text inputs. All inputs should be the same size. */
    .ant-picker-input {
      padding: 0px;
    }
  }
`;

export const TemplateTitle = styled.span`
  flex: 1 0 auto;
  margin-left: ${theme.space[4]};
  font-size: ${theme.fontSizes[3]};
  line-height: 23px;
  color: ${theme.colors.darkBlues[100]};
`;

export const TemplateX = styled(Button)`
  width: 55px;
  color: ${theme.colors.darkBlues[100]};
  font-size: ${theme.fontSizes[4]};
  height: 100%;
  border: none;
  border-left: 1px solid #ecf1f5;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 0px;
`;

export const Footer = styled(Flex)`
  grid-area: footer;
  height: 100%;
  width: 100%;
  border-top: 2px solid #ecf1f5;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
`;

export const LeftButton = styled(Button)`
  margin: ${theme.space[0]} 26px;
  margin-right: auto;
`;

export const RightButton = styled(Button)`
  margin: ${theme.space[0]} 26px;
  margin-left: auto;
`;
